
export default {

    methods: {
        convertElements(elements, type, parentId) {
            let result = [];
            elements.forEach((element) => {
                let newElement = this.convertElement(element, type, parentId);
                result.push(newElement);
            });

            return result;
        },
        convertElement(element, type, parentId) {
            let result = _.clone(element);

            if (element.hasOwnProperty('name')) {
                result.label = element.name;
            }

            if (element.hasOwnProperty('title')) {
                result.label = element.title;
            }

            this.$set(result, 'children', []);

            result.getRealId = () => {
                return result.id;
            }

            result.type = type;

            result.guid = this.$uuidKey();
            result.parentId = parentId;

            return result;
        }
    }
}